<ng-container *ngIf="notifications$ | async as notifications">
	<mat-card *ngFor="let notification of notifications"
			  class="notification-card list-item-card"
			  [ngClass]="{ 'notification-card-unread': !notification.isRead }">
		<mat-card-content (click)="goToOrder(notification)">
			<div class="card-grid">
				<mat-chip-set class="status-chip-list">
					<mat-basic-chip *ngIf="notification.subType === NotificationTypes.APPROVED"
									class="branding--notification-approved">{{ "SYS_NOTIFICATIONS.NOTIFICATION_TYPES.APPROVED" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="notification.subType === NotificationTypes.MODIFIED"
									class="branding--notification-modified">{{ "SYS_NOTIFICATIONS.NOTIFICATION_TYPES.MODIFIED" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="notification.subType === NotificationTypes.REJECTED"
									class="branding--notification-rejected">{{ "SYS_NOTIFICATIONS.NOTIFICATION_TYPES.REJECTED" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="notification.subType === NotificationTypes.CONFIRM_DEADLINE_WARNING"
									class="branding--notification-confirm-deadline-warning">{{ "SYS_NOTIFICATIONS.NOTIFICATION_TYPES.CONFIRM_DEADLINE_WARNING" | translate }}</mat-basic-chip>
					<mat-basic-chip *ngIf="notification.subType === NotificationTypes.CONFIRM_DEADLINE_PASSED"
									class="branding--notification-confirm-deadline-passed">{{ "SYS_NOTIFICATIONS.NOTIFICATION_TYPES.CONFIRM_DEADLINE_PASSED" | translate }}</mat-basic-chip>
				</mat-chip-set>
				<app-order-id-chip class="order-id-chip" [orderID]="notification.orderId" [description]="notification.campaignName"></app-order-id-chip>
				<div class="timestamp">
					{{ notification.timestamp | cassTimestamp }}
				</div>
				<div class="message-block">
					<span class="message-sender">
						{{
							(notification.senderUserName ?? ("SYS_NOTIFICATIONS.UNKNOWN_SENDER_LABEL" | translate))
							+ (notification.senderCompanyId ? " (" + getCompanyNameById(notification.senderCompanyId) + ")" : "")
							+ ": "
						}}
					</span>
					<span class="message-text">{{ notification.messageText }}</span>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
	<mat-card class="no-items" *ngIf="notifications.length === 0">
		<mat-card-header>
			<mat-chip-set>
				<mat-basic-chip>{{ (showNewSinceLastLogin ? "SYS_NOTIFICATIONS.NOTIFICATIONS_PAGE.NO_NEW_NOTIFICATIONS_ALERT" : "SYS_NOTIFICATIONS.NOTIFICATIONS_PAGE.NO_NOTIFICATIONS_ALERT") | translate }}</mat-basic-chip>
			</mat-chip-set>
		</mat-card-header>
	</mat-card>
</ng-container>
<ng-container *ngIf="!(callingOut$ | async); else loading">
</ng-container>
<ng-template #loading>
	<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
</ng-template>
